/**
 * 多语言平台标识
 */
export const LGPlatformEnum = {
  META_ADMIN_WEB: 'META_ADMIN_WEB',
  META_LANDING_PAGE: 'META_LANDING_PAGE',
  META_HOME: 'META_HOME',
  META_EDITER: 'META_EDITER'
}

/**
 * 多语言oss资源路径
 */
export const LGOssPathEnum = {
  /**
   * 语言标识配置
   */
  LG_CONFIG: 'language/config/',
  /**
   * 后台管理系统
   */
  META_ADMIN_WEB: 'language/meta-admin-web/',
  /**
   * 活动落地页
   */
  META_LANDING_PAGE: 'language/meta-landing-page/',
  /**
   * 官网
   */
  META_HOME: 'language/meta-home/',
  /*
   * 活动编辑器
   */
  META_EDITER: 'language/meta-editer/'
}

/**
 * 多语言文件名
 */
export const LGFileNameEnum = {
  /**
   * 语言标识配置
   */
  LG_CONFIG: 'config.json',
  /**
   * 文本多语言配置
   */
  LG_LABEL: 'label.json'
}

/**
 * 项目名称选项
 */
export const LGProjects = [
  {
    label: '后台管理系统',
    value: 'META_ADMIN_WEB'
  },
  {
    label: '活动落地页',
    value: 'META_LANDING_PAGE'
  },
  {
    label: '官网',
    value: 'META_HOME'
  },
  {
    label: '活动编辑器',
    value: 'META_EDITER'
  }
]
